import { render, staticRenderFns } from "./progress-loading.vue?vue&type=template&id=004adf82&scoped=true"
import script from "./progress-loading.vue?vue&type=script&lang=js"
export * from "./progress-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004adf82",
  null
  
)

export default component.exports